'use strict';

export const SERVED_NOTES_URL = 'https://foorenxiang.github.io/static/servedNotes.json';
export const NOTES_REPOSITORY_URL = 'https://raw.githubusercontent.com/foorenxiang/notes/main/';
export const LANGUAGE_EXTENSIONS_DESCRIPTORS_URL =
  'https://gist.githubusercontent.com/foorenxiang/510c312f129b98a677329fd5d491e4e5/raw/211547723b4621a622fc56978d74aa416cbd1729/Programming_Languages_Extensions.json';
